import { PagerSettings } from "@progress/kendo-angular-grid";

export const PageableOptions: PagerSettings = {
    pageSizes: [10, 25, 50, 100]
};
